import { ACCOUNTSTYPES, EMBEDTYPES } from '@/utils/embeds/accountMeta'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export interface IEmbed {
  id: number
  embedKey: string
  name: string
  type: (typeof EMBEDTYPES)[keyof typeof EMBEDTYPES]
  views: number
  executions: number
  createdOn: string
  modifiedOn: string
  draftUpdatedAt: string | null
}
export interface IDomain {
  id: number
  domain: string
}

export const useEmbedManagerStore = defineStore('embedManager', () => {
  const acountType = ref<string>(ACCOUNTSTYPES.FREE)
  const allowedDomains = ref<number>(0)
  const allowedPremiumEmbeds = ref<number>(0)
  const allowedUltraEmbeds = ref<number>(0)

  const embeds = ref<IEmbed[]>([])
  const domains = ref<IDomain[]>([])

  const getCodeFlag = ref<boolean>(false)

  const getAccountType = computed(() => {
    return acountType.value
  })
  const getAllowedDomains = computed(() => {
    return allowedDomains.value
  })
  const getAllowedPremiumEmbeds = computed(() => {
    return allowedPremiumEmbeds.value
  })
  const getAllowedUltraEmbeds = computed(() => {
    return allowedUltraEmbeds.value
  })

  const getEmbeds = computed(() => {
    return embeds.value || []
  })
  const getDomains = computed(() => {
    return domains.value || []
  })

  const getGetCodeFlag = computed(() => {
    return getCodeFlag.value
  })

  /**
   * Set the account type
   * @param key - The account type
   */
  const setAccontType = (key: string) => {
    acountType.value = key
  }
  /**
   * Set the allowed domains
   * @param data - The allowed domains
   */
  const setAllowedDomains = (data: number) => {
    allowedDomains.value = data
  }
  /**
   * Set the allowed premium embeds
   * @param data - The allowed premium embeds
   */
  const setAllowedPremiumEmbeds = (data: number) => {
    allowedPremiumEmbeds.value = data
  }
  /**
   * Set the allowed ultra embeds
   * @param data - The allowed ultra embeds
   */
  const setAllowedUltraEmbeds = (data: number) => {
    allowedUltraEmbeds.value = data
  }
  /**
   * Add an embed
   * @param data - The embed
   */
  const addEmbed = (data: IEmbed) => {
    embeds.value.push(data)
  }
  /**
   * Delete an embed
   * @param data - The embed
   */
  const deleteEmbed = (data: IEmbed) => {
    embeds.value = embeds.value.filter((embed) => embed.id !== data.id)
  }
  /**
   * Set the embeds
   * @param data - The embeds
   */
  const setEmbeds = (data: IEmbed[]) => {
    embeds.value = data || []
  }
  /**
   * Set the domains
   * @param data - The domains
   */
  const setDomains = (data: IDomain[]) => {
    domains.value = data || []
  }
  /**
   * Add a domain
   * @param data - The domain
   */
  const addDomain = (data: IDomain) => {
    domains.value.push(data)
  }

  /**
   * Set the get code flag
   * @param data - The get code flag
   */
  const setGetCodeFlag = (data: boolean) => {
    getCodeFlag.value = data
  }
  return {
    getAccountType,
    setAccontType,
    getAllowedDomains,
    setAllowedDomains,
    getAllowedPremiumEmbeds,
    setAllowedPremiumEmbeds,
    getAllowedUltraEmbeds,
    setAllowedUltraEmbeds,
    getEmbeds,
    deleteEmbed,
    addEmbed,
    setEmbeds,
    getDomains,
    setDomains,
    addDomain,
    getGetCodeFlag,
    setGetCodeFlag
  }
})
